import { cn, ClassValue } from "@/libs/utils/tailwind/cn";

export default function ListOutlineIcon({ className }: Props) {
  return (
    <svg
      className={cn("size-10 text-primary", className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M26.667 6.66634H30.0003C30.8844 6.66634 31.7322 7.01753 32.3573 7.64265C32.9825 8.26777 33.3337 9.11562 33.3337 9.99967V33.333C33.3337 34.2171 32.9825 35.0649 32.3573 35.69C31.7322 36.3152 30.8844 36.6663 30.0003 36.6663H10.0003C9.11627 36.6663 8.26842 36.3152 7.6433 35.69C7.01818 35.0649 6.66699 34.2171 6.66699 33.333V9.99967C6.66699 9.11562 7.01818 8.26777 7.6433 7.64265C8.26842 7.01753 9.11627 6.66634 10.0003 6.66634H13.3337M15.0003 3.33301H25.0003C25.9208 3.33301 26.667 4.0792 26.667 4.99967V8.33301C26.667 9.25348 25.9208 9.99967 25.0003 9.99967H15.0003C14.0799 9.99967 13.3337 9.25348 13.3337 8.33301V4.99967C13.3337 4.0792 14.0799 3.33301 15.0003 3.33301Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface Props {
  className?: ClassValue;
}
